var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingAndStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 274,
    viewBox: "0 0 274 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.025 29.1371C179.944 28.9208 179.638 28.9208 179.557 29.1371L174.237 43.3236L164.513 46.5647C164.285 46.6407 164.285 46.9631 164.513 47.0391L174.233 50.2788L179.557 64.476C179.638 64.6923 179.944 64.6923 180.025 64.476L185.343 50.293L195.105 47.0391C195.333 46.9631 195.333 46.6407 195.105 46.5647L185.339 43.3095L180.025 29.1371ZM182.097 46.8054H177.521V46.8076L182.097 46.8077V46.8054ZM65.6828 116.066C65.6017 115.85 65.2957 115.85 65.2146 116.066L60.8455 127.717L52.9213 130.358C52.6933 130.434 52.6933 130.757 52.9213 130.832L60.8456 133.474L65.2146 145.125C65.2957 145.341 65.6017 145.341 65.6828 145.125L70.0477 133.485L78.0042 130.832C78.2321 130.757 78.2321 130.434 78.0042 130.358L70.0479 127.706L65.6828 116.066ZM31.4338 193.637C31.5149 193.42 31.8209 193.42 31.902 193.637L36.267 205.277L44.2234 207.929C44.4513 208.005 44.4513 208.327 44.2234 208.403L36.2669 211.055L31.902 222.695C31.8209 222.912 31.5149 222.912 31.4338 222.695L27.0648 211.045L19.1404 208.403C18.9125 208.327 18.9125 208.005 19.1404 207.929L27.0647 205.287L31.4338 193.637ZM71.1623 223.038C71.2434 222.822 71.5493 222.822 71.6304 223.038L78.0567 240.175L89.9036 244.124C90.1315 244.2 90.1315 244.522 89.9036 244.598L78.0587 248.547L71.6304 265.689C71.5493 265.905 71.2434 265.905 71.1623 265.689L64.7294 248.534L52.9213 244.598C52.6933 244.522 52.6933 244.2 52.9213 244.124L64.7314 240.187L71.1623 223.038ZM219.105 179.874C219.186 179.658 219.492 179.658 219.573 179.874L223.938 191.514L231.895 194.166C232.123 194.242 232.123 194.565 231.895 194.641L223.938 197.293L219.573 208.933C219.492 209.149 219.186 209.149 219.105 208.933L214.736 197.282L206.812 194.641C206.584 194.565 206.584 194.242 206.812 194.166L214.736 191.525L219.105 179.874ZM224.793 81.6672C224.873 81.4484 225.182 81.4484 225.262 81.6672L231.376 98.3782L242.624 102.221C242.849 102.298 242.849 102.617 242.624 102.694L231.374 106.538L225.262 123.243C225.182 123.462 224.873 123.462 224.793 123.243L218.681 106.539L207.429 102.694C207.203 102.617 207.203 102.298 207.429 102.221L218.679 98.3772L224.793 81.6672ZM222.416 102.454H227.637V102.457L222.416 102.457V102.454Z",
    fill: "url(#paint0_linear_287_10294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.315 130.157C147.315 127.766 149.25 125.827 151.637 125.827H166.042C168.429 125.827 170.364 127.766 170.364 130.157C170.364 132.548 168.429 134.486 166.042 134.486H151.637C149.25 134.486 147.315 132.548 147.315 130.157Z",
    fill: "url(#paint1_linear_287_10294)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.505 130.157C118.505 127.766 120.44 125.827 122.827 125.827H137.232C139.618 125.827 141.553 127.766 141.553 130.157C141.553 132.548 139.618 134.486 137.232 134.486H122.827C120.44 134.486 118.505 132.548 118.505 130.157Z",
    fill: "url(#paint2_linear_287_10294)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.315 144.588C147.315 142.197 149.25 140.259 151.637 140.259H166.042C168.429 140.259 170.364 142.197 170.364 144.588C170.364 146.979 168.429 148.917 166.042 148.917H151.637C149.25 148.917 147.315 146.979 147.315 144.588Z",
    fill: "url(#paint3_linear_287_10294)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.505 144.588C118.505 142.197 120.44 140.259 122.827 140.259H137.232C139.618 140.259 141.553 142.197 141.553 144.588C141.553 146.979 139.618 148.917 137.232 148.917H122.827C120.44 148.917 118.505 146.979 118.505 144.588Z",
    fill: "url(#paint4_linear_287_10294)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.315 116.875C147.315 114.484 149.25 112.546 151.637 112.546H166.042C168.429 112.546 170.364 114.484 170.364 116.875C170.364 119.266 168.429 121.205 166.042 121.205H151.637C149.25 121.205 147.315 119.266 147.315 116.875Z",
    fill: "url(#paint5_linear_287_10294)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.566 91.5079C177.566 90.4577 176.482 89.7592 175.528 90.1946L112.146 119.126C111.632 119.36 111.302 119.874 111.302 120.439V154.69H102.659V120.439C102.659 116.481 104.967 112.887 108.562 111.246L171.945 82.3151C178.622 79.2673 186.209 84.1569 186.209 91.5079V200.871H177.566V91.5079Z",
    fill: "url(#paint6_linear_287_10294)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0163 159.023C94.0163 158.115 94.8433 157.432 95.7329 157.606L159.116 170.005C159.792 170.138 160.28 170.731 160.28 171.422V200.871H168.923V171.422C168.923 166.589 165.506 162.433 160.772 161.507L97.3893 149.108C91.1624 147.89 85.3732 152.667 85.3732 159.023V200.871H94.0163V159.023Z",
    fill: "url(#paint7_linear_287_10294)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1706 205.2C78.1706 202.809 80.1054 200.871 82.4922 200.871H189.09C191.477 200.871 193.412 202.809 193.412 205.2C193.412 207.591 191.477 209.529 189.09 209.529H82.4922C80.1054 209.529 78.1706 207.591 78.1706 205.2Z",
    fill: "url(#paint8_linear_287_10294)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.183 186.439C114.183 180.86 118.698 176.337 124.267 176.337H130.029C135.598 176.337 140.113 180.86 140.113 186.439V200.871H131.47V186.439C131.47 185.642 130.825 184.996 130.029 184.996H124.267C123.472 184.996 122.827 185.642 122.827 186.439V200.871H114.183V186.439Z",
    fill: "url(#paint9_linear_287_10294)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_10294",
    x1: 217.641,
    y1: -1539.01,
    x2: 655.657,
    y2: -1502.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_287_10294",
    x1: 180.462,
    y1: -766.788,
    x2: 406.129,
    y2: -749.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingAndStars);
export default __webpack_public_path__ + "static/media/building-and-stars.ba3459443dbdb26b8fbcf6492bb48f0b.svg";
export { ForwardRef as ReactComponent };